/** Převod device topicu mezi konkrétním slugem a {slug} šablonou (jen prefix `zige/<type>-<slug>/`).
 *  Render-time opačný směr ({slug}→slug) dělá slugify v config/layoutWidgets.tsx. */

export const isTemplatedTopic = (topic: string): boolean => topic.includes("{slug}");

/** `zige/pip-main/x/val` → `zige/pip-{slug}/x/val` (jen když prefix sedí na deviceType+slug). */
export const templatizeTopic = (topic: string, deviceType?: string, slug?: string): string => {
  if (!deviceType || !slug) return topic;
  const concrete = `zige/${deviceType}-${slug}/`;
  return topic.startsWith(concrete) ? `zige/${deviceType}-{slug}/` + topic.slice(concrete.length) : topic;
};

/** `zige/pip-{slug}/x/val` → `zige/pip-main/x/val` (pro zobrazení v TopicPickeru / match na DB topic). */
export const concretizeTopic = (topic: string, deviceType?: string, slug?: string): string => {
  if (!deviceType || !slug) return topic;
  const tpl = `zige/${deviceType}-{slug}/`;
  return topic.startsWith(tpl) ? `zige/${deviceType}-${slug}/` + topic.slice(tpl.length) : topic;
};
